import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const RangerDeployment = ({ rangers }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'on-patrol':
        return 'bg-success';
      case 'responding':
        return 'bg-warning';
      case 'off-duty':
        return 'bg-muted';
      default:
        return 'bg-border';
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'on-patrol':
        return 'On Patrol';
      case 'responding':
        return 'Responding';
      case 'off-duty':
        return 'Off Duty';
      default:
        return 'Unknown';
    }
  };

  return (
    <div className="bg-card rounded-lg p-6 shadow-conservation">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-semibold text-gray-900 dark:text-white">Ranger Deployment</h3>
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 bg-success rounded-full pulse-conservation"></div>
          <span className="text-sm text-gray-600 dark:text-gray-300">{rangers?.filter(r => r?.status === 'on-patrol')?.length} Active</span>
        </div>
      </div>
      <div className="space-y-4">
        {rangers?.map((ranger) => (
          <div key={ranger?.id} className="flex items-center gap-4 p-4 border border-border rounded-lg animation-organic hover:border-primary/50">
            <div className="relative flex-shrink-0">
              <div className="w-12 h-12 rounded-full overflow-hidden">
                <Image 
                  src={ranger?.avatar} 
                  alt={ranger?.avatarAlt}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className={`absolute -bottom-1 -right-1 w-4 h-4 ${getStatusColor(ranger?.status)} rounded-full border-2 border-card`}></div>
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="font-medium text-gray-900 dark:text-white mb-1">{ranger?.name}</h4>
              <p className="text-sm text-gray-600 dark:text-gray-300 mb-2">{ranger?.zone}</p>
              <div className="flex items-center gap-4 text-xs">
                <div className="flex items-center gap-1">
                  <Icon name="MapPin" size={12} color="var(--color-muted-foreground)" />
                  <span className="text-gray-600 dark:text-gray-300">{ranger?.currentLocation}</span>
                </div>
                <span className={`px-2 py-0.5 rounded text-xs font-medium ${getStatusColor(ranger?.status)} text-white`}>
                  {getStatusLabel(ranger?.status)}
                </span>
              </div>
            </div>
            <div className="flex-shrink-0">
              <button 
                className="p-2 hover:bg-muted rounded-lg transition-colors"
                aria-label={`Contact ${ranger?.name}`}
              >
                <Icon name="Radio" size={18} color="var(--color-primary)" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RangerDeployment;